import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SettingSystemComponent } from './setting-system.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    FormsModule,
    Daterangepicker
  ],
  declarations: [SettingSystemComponent],
  exports: [
    SettingSystemComponent
  ],
  providers: [
    
  ]
})
export class SettingSystemModule { }
